import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import logo from '../../assets/images/eSprawozdania_StartErrorPage.svg'
import LicencjaHeader from './LicencjaHeader'
import LicencjaErorrInfo from './LicencjaErrorInfo'
import StartFooter from './StartFooter'
import Button from '@material-ui/core/Button'

class StartErrorPage extends Component {
  reload = () => {
    const { header, onDownloadSections } = this.props
    if (header && header.Id) onDownloadSections(header.Id, 1)
    else window.location.reload()
  }

  render = () => {
    const { licencja, error } = this.props
    return (
      <>
        <section>
          <header>
            <LicencjaHeader licencja={licencja} />
          </header>
          <main>
            {(!error || error.includes('Błąd sprawdzenia licencji')) && (
              <img src={logo} alt="logo" />
            )}
            {!error || error.includes('Błąd sprawdzenia licencji') ? (
              <>
                <LicencjaErorrInfo licencja={licencja} error={error} />
                <div className="secondaryText">
                  Jeżeli chcesz skorzystać z programu, a nie posiadasz licencji
                  lub masz problem z jego uruchomieniem
                  <br />
                  skontaktuj się z nami.
                </div>
              </>
            ) : (
              <>
                {error ? (
                  <>
                    <h1>Wystąpił błąd po stronie serwera</h1>
                    <p className="secondaryText">Treść błędu: "{error}"</p>
                  </>
                ) : (
                  <h1>Przykro nam, ale coś poszło nie tak...</h1>
                )}
                <p className="secondaryText">
                  Spróbuj ponownie.
                  <br />
                  Jeśli problem będzie się powtarzał, skontaktuj się z nami.
                </p>
                <Button
                  className="firstButton"
                  variant="contained"
                  color="primary"
                  onClick={this.reload}
                >
                  SPRÓBUJ PONOWNIE
                </Button>
              </>
            )}
          </main>
        </section>
        <footer>
          <StartFooter />
        </footer>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    licencja: state.sprawozdanie.licencja,
    header: state.sprawozdanie.header,
    error: state.sprawozdanie.err,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onDownloadSections: (id, page) =>
      dispatch(actions.downloadSections(id, page)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StartErrorPage)
